import axios from 'axios';
import _ from 'lodash';

import { url } from '../config';

// Redux Actions
import {
    FETCH_BTSWP_START,
    FAILED_BTSWP,
    FETCH_BTSWP,
} from '../actions/index.jsx';

// Axios Request
export const fetchBtsWp = () => {
    const wp = () => {
        return axios.get(`${url}/wp-json/wp/v2/posts`);
    };

    const feed = () => {
        return axios.get(`${url}/wp-json/wp/v2/feed`);
    };

    return function (dispatch) {
        dispatch({ type: FETCH_BTSWP_START });
        axios
            .all([wp(), feed()])
            .then(
                axios.spread(function (wp, feed) {
                    wp = wp.data;
                    feed = feed.data;
                    const BTSfeedObj = [];

                    const wpObj = [];
                    for (let i = 0; i < wp.length; i++) {
                        let hasFeaturedImage = false;
                        let featuredImage = null;
                        if (wp[i].better_featured_image) {
                            hasFeaturedImage = true;
                            if (
                                wp[i].better_featured_image.media_details.sizes
                                    .img_square_big
                            ) {
                                featuredImage =
                                    wp[i].better_featured_image.media_details
                                        .sizes.img_square_big.source_url;
                            } else if (
                                wp[i].better_featured_image.media_details.sizes
                                    .img_square
                            ) {
                                featuredImage =
                                    wp[i].better_featured_image.media_details
                                        .sizes.img_square.source_url;
                            } else {
                                featuredImage =
                                    wp[i].better_featured_image.media_details
                                        .sizes.thumbnail.source_url;
                            }
                        }

                        // Wordpress Friends Object
                        wpObj[i] = {
                            postdata: wp[i].date,
                            title: wp[i].title.rendered,
                            excerpt: wp[i].excerpt.rendered,
                            slug: wp[i].slug,
                            type: 'wordpress',
                            posttype: wp[i].acf.type,
                            wp_id: wp[i].id,
                            hasFeaturedImage: hasFeaturedImage,
                            image: featuredImage,
                        };
                    }

                    const feedObj = [];
                    for (let i = 0; i < feed.length; i++) {
                        let hasFeaturedImage = false;
                        let featuredImage = null;
                        if (feed[i].better_featured_image) {
                            hasFeaturedImage = true;
                            if (
                                feed[i].better_featured_image.media_details
                                    .sizes.img_square
                            ) {
                                featuredImage =
                                    feed[i].better_featured_image.media_details
                                        .sizes.img_square.source_url;
                            } else {
                                featuredImage =
                                    feed[i].better_featured_image.media_details
                                        .sizes.thumbnail.source_url;
                            }
                        }
                        // remove <p> from string
                        let content = feed[i].content.rendered.replace(
                            /<(.|\n)*?>/g,
                            ''
                        );

                        // push seperated tags in new array.
                        // let tags = feed[i].pure_taxonomies.tags[0].slug;
                        // let wpTags = [];
                        //  wpTags.push(tags);

                        feedObj[i] = {
                            postdata: feed[i].date,
                            title: feed[i].title.rendered,
                            slug: feed[i].slug,
                            caption: content,
                            type: 'wordpress',
                            posttype: 'feed',
                            wp_id: feed[i].id,
                            hasFeaturedImage: hasFeaturedImage,
                            image: featuredImage,
                            // tags: wpTags,
                        };
                    }

                    let allObj = BTSfeedObj.concat(wpObj, feedObj);
                    allObj = _.sortBy(allObj, 'postdata').reverse();
                    dispatch({
                        type: FETCH_BTSWP,
                        payload: allObj,
                    });
                })
            )
            .catch(function (error) {
                console.log(error);
                dispatch({
                    type: FAILED_BTSWP,
                });
            });
    };
};



// WEBPACK FOOTER //
// ./src/requests/bts_request.js